import { Button, Dialog } from '@mui/material';
import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';

// The lazy-recheck "deal is gone" dialog. Deliberately not a RESERVATION_DIALOG_VARIANT: the
// design is left-aligned, has no icon and a single action, where every ReservationDialog variant
// is centred around an illustration. Keeps `reservation-dialog-select-another-room` on the button
// because the e2e lazy-recheck races locate this dialog by that testid.
function DealUnavailableDialog({ modalIsOpen, onBack, roomName, t }) {
    return (
        <Dialog
            className="deal-unavailable-dialog-main"
            open={modalIsOpen}
            aria-describedby="deal-unavailable-dialog-description"
            fullWidth={true}
        >
            <div className="deal-unavailable-container" data-testid="deal-unavailable-dialog">
                <h3 className="deal-unavailable-title">{t('DealUnavailableDialog.Title')}</h3>

                {roomName ? (
                    <div className="deal-unavailable-room-name" data-testid="deal-unavailable-room-name">
                        {roomName}
                    </div>
                ) : null}

                <p className="deal-unavailable-message" id="deal-unavailable-dialog-description">
                    {t('DealUnavailableDialog.Message')}
                </p>

                <div className="deal-unavailable-actions">
                    <Button
                        className="deal-unavailable-btn-confirm"
                        data-testid="reservation-dialog-select-another-room"
                        variant="contained"
                        onClick={onBack}
                    >
                        {t('ReservationDialog.SelectAnotherRoomButton')}
                    </Button>
                </div>
            </div>
        </Dialog>
    );
}

DealUnavailableDialog.propTypes = {
    modalIsOpen: PropTypes.bool.isRequired,
    onBack: PropTypes.func.isRequired,
    roomName: PropTypes.string,
    t: PropTypes.func.isRequired,
};

export default memo(withTranslation()(DealUnavailableDialog));
